@if (client) {
  <div class="card h-100">
    <div class="card-body pt-1">
      <div class="d-flex flex-column align-items-center">
        <div class="d-flex crop">
          <a [routerLink]="'/client/' + client._id">
            <img class="" [src]="client.image || profilePics.default" alt="">
          </a>
        </div>
        @if (isDetailsPage && auth.isAdmin) {
          <button class="btn btn-sm btn-primary py-0 px-1 mt-1 hide-print" data-bs-toggle="modal"
            data-bs-target="#edit-client-modal" (click)="toggleEditClientModal('image')">
            <i class="fa fa-pencil"></i> Edit
          </button>
        }
      </div>
      <div class="d-flex flex-column">
        <h5 class="card-title mt-1">
          <a [routerLink]="'/client/' + client._id">
            {{client.name}}
          </a>
          @if (isDetailsPage) {
            <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-client-modal" (click)="toggleEditClientModal('name')">
              <i class="fa fa-pencil"></i> Edit
            </button>
          }
          @if (isDetailsPage) {
            <app-delete-btn-admin (click)="deleteClient(client)"></app-delete-btn-admin>
          }
        </h5>
        <div class="card-subtitle">
          Topic: {{client.cluster}}
          @if (isDetailsPage) {
            <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-client-modal" (click)="toggleEditClientModal('cluster')">
              <i class="fa fa-pencil"></i>
            </button>
          }
        </div>
        <div class="card-subtitle mt-1">
          Category: {{client.category || 'No category'}}
          @if (isDetailsPage) {
            <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-client-modal" (click)="toggleEditClientModal('category')">
              <i class="fa fa-pencil"></i>
            </button>
          }
        </div>
        <div class="card-subtitle mt-1">
          Services: {{lastContractName || 'No services'}}
        </div>
        @if (client._users.length) {
          <div class="card-subtitle mt-1">
            Coordinators:
            @for (user of client._users; track user; let last = $last) {
              <span>
                <a [routerLink]="'/user/' + user._id">{{user.firstName}} {{user.lastName}}</a>@if (!last) {
                <span>, </span>
              }
            </span>
          }
          @if (isDetailsPage) {
            <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-client-modal" (click)="toggleEditClientModal('_users')">
              <i class="fa fa-pencil"></i>
            </button>
          }
        </div>
      }
      @if (!client._users.length) {
        <div class="mt-1">
          @if (isDetailsPage) {
            <button class="btn btn-sm btn-primary py-0 px-1 ms-1 hide-print" data-bs-toggle="modal" data-bs-target="#edit-client-modal" (click)="toggleEditClientModal('_users')">
              <i class="fa fa-pencil"></i> Add coordinators
            </button>
          }
        </div>
      }
    </div>
    <div class="mt-2 text-muted small float-end">
      added on {{client.created_at | date}}
    </div>
  </div>
</div>
}

@if (isEditClientModalVisible) {
  <app-edit-client-modal [client]="client" [field]="field"></app-edit-client-modal>
}